module.exports = __webpack_public_path__ + "static/kitchen.d44913e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pc/kitchen.jpg
// module id = 509
// module chunks = 274152660091841